import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { missionClientText } from "i18n/client";
import { missionEventText } from "i18n/Events";
import ImageSlider from "Util/ImageSlider";
import { slides } from "data/slide";

const MissionEvent = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = missionEventText[lang];
  const navigate = useNavigate();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="hidden lg:block relative w-full mt-[80px]">
        <ImageSlider slides={slides} variant="desktop" />
      </div>

      {/* ===== MOBILE GRID VERSION ===== */}
      <div className="lg:hidden flex  mt-[80px]">
        <ImageSlider slides={slides} variant="mobile" />
      </div>
    </section>
  );
};

export default MissionEvent;
